<template>
    <div class='t_content_view'>
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.corp_id" @change="changezt" clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.title" placeholder="请输入任务名称"  clearable />
            </div> 
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchpeng" size="small" v-model="searchdata.content" placeholder="请输入朋友圈内容"  clearable />
            </div> 
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">执行时间：</span>
                <el-date-picker
                    size="small" 
                    @change="changeTime"
                    v-model="choosetime.data"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">任务状态：</span>
                <el-select size="small"
                style="width: 180px;"
                @change="searchselect"
                v-model="searchdata.status" clearable placeholder="请选择">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </div> 
            
        </div>
        <div style="margin-bottom: 20px;">
            <el-button @click="resetsearch" color="#F1F3F9" type="primary">重置</el-button>
            <!-- <el-button @click="createmsg" color="#4F46E5" type="primary">新建群发</el-button>
            <el-button @click="xianshibtn" color="#F1F3F9" type="primary">发送限时</el-button> -->
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" :default-sort="{ prop: 'createTime', order: 'descending' }" style="width: 100%">
            <el-table-column prop="corp_name"  label="主体" />
            <el-table-column prop="title"  label="任务名称" />
            <el-table-column prop="created_at"  label="创建时间" />
            <el-table-column prop="publish_time"  label="发布时间" />
            <el-table-column prop="content" label="发送内容"  >
                <template #default="scope">
                   <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width: 100%;">
                    {{ scope.row.content }}
                   </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="sender"  label="创建成员" /> -->
            
            <!-- <el-table-column prop="sendNames" label="发送成员" >
                <template #default="scope">
                   <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width: 100%;">
                    <el-tooltip class="item" effect="dark" :content="scope.row.sendNames" placement="top-start">
                        <div>{{ scope.row.sendNames }}</div>
                    </el-tooltip>
                    
                   </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="sendNames" label="发送设备" >
                <template #default="scope">
                   <span @click="opensendtype(scope.row)" style="color:#4F46E5;cursor: pointer;">{{ scope.row.success_count }}/{{ scope.row.count }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="sendNames" label="任务状态" >
                <template #default="scope">
                   <span v-if="scope.row.status==0" style="color:#7A7A7A">等待发送</span>
                   <span v-if="scope.row.status==1" style="color:#FE1C1C">部分成功</span>
                   <span v-if="scope.row.status==2" style="color:#00BA13">发布成功</span>
                   <span v-if="scope.row.status==3" style="color:#820000">发布失败</span>
                   <span v-if="scope.row.status==4" style="color:#000b82">已终止任务</span>
                   <span v-if="scope.row.status==5" style="color:#df8928">已删除任务</span>
                </template>
            </el-table-column>
            <el-table-column prop="like_num" label="点赞数" ></el-table-column>
            <el-table-column prop="comment_num" label="评论数" ></el-table-column>
            <el-table-column prop="address" label="操作">
                <template #default="scope">
                    <el-button style="color:#4F46E5" size="small" type="text" @click="todetail(scope.row.id)">编辑发送</el-button>
                    <!-- <el-button v-if="scope.row.status==0" style="color:#4F46E5" size="small" type="text" @click="detailbtn(scope.row.id)">终止</el-button> -->
                    <el-button v-if="scope.row.status!=5&&scope.row.status!=0" style="color:#4F46E5" size="small" type="text" @click="detailbtn(scope.row.id)">删除</el-button>
                    <el-button @click="stopbtn(scope.row.id)" style="color:#4F46E5" size="small" type="text" >终止</el-button>
                    <!-- <el-button v-if="scope.row.status==5" @click="opendelrest(scope.row)" style="color:#4F46E5" size="small" type="text" >删除结果</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
    <!-- 发送状态弹窗 -->
    <el-dialog
        v-model="isshowsendtype"
        title="发送结果"
        width="500px"
    >
        <el-table :data="sendtypeData.data" >
            <el-table-column prop="name" label="设备账号"  />
            <el-table-column prop="name" label="发送状态"  >
                <template #default="scope">
                   <span style="color:#7A7A7A">{{ MOMENT_SEND_STATUS[scope.row.status] || '未知' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" >
                <template #default="scope">
                   <span @click="restsend(scope.row.id)" style="color:#4F46E5;cursor: pointer;">重发</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 20px;">
            <el-button @click="isshowsendtype=false">关闭</el-button>
        </div>
    </el-dialog>
    <!-- 删除结果弹窗 -->
    <el-dialog
        v-model="isshowdelrest"
        title="删除结果"
        width="500px"
    >
        <el-table :data="delrestData.data" >
            <el-table-column prop="wxName" label="设备账号"  />
            <el-table-column prop="name" label="发送状态"  >
                <template #default="scope">
                   <span v-if="scope.row.status==0" style="color:#7A7A7A">未执行</span>
                   <span v-if="scope.row.status==1" style="color:#7A7A7A">已执行</span>
                   <span v-if="scope.row.status==2" style="color:#7A7A7A">成功</span>
                   <span v-if="scope.row.status==3" style="color:#7A7A7A">删除未执行</span>
                   <span v-if="scope.row.status==4" style="color:#7A7A7A">删除执行</span>
                   <span v-if="scope.row.status==5" style="color:#7A7A7A">删除成功</span>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" >
                <template #default="scope">
                   <span @click="restdel(scope.row.id)" style="color:#4F46E5;cursor: pointer;">重新执行</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: center;margin-top: 20px;">
            <el-button @click="isshowdelrest=false">关闭</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { getcirclelist,delcircle,sendrestlist,repset,newsendfriendlist,newdelfriendcircle,newsendlist,newrepsend,newstopsend,newgetcomp2} from '@/assets/js/common.js'
//获取路由参数 
const route = useRoute()
//路由跳转
const router = useRouter()

//动态获取接口地址
const _url2 = inject('_url2')

//朋友圈发送记录(/api/moment/send/log)状态映射：0=待发送 2=发送成功 3=发送失败 4=设备离线发送失败
const MOMENT_SEND_STATUS = {
    0: '待发送',
    2: '发送成功',
    3: '发送失败',
    4: '设备离线发送失败'
}
onMounted(() => {
    console.log('onMounted')
    getlist()
    //获取企微主体下拉
    getcorplist()
})
//搜索内容
const searchdata  = reactive({
   
    page:1,
    page_size:20,
    title:'',
    status:'',
    send_time_start:'',
    send_time_end:'',
    content:'',
    corp_id:''
})
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
//企微主体下拉变化
const changezt = (val)=>{
    console.log(val)
    searchdata.corp_id = val
    searchdata.page = 1
    getlist()

}
//选择时间
const choosetime = reactive({
    data:[]
})
//选择时间
const changeTime = (val)=>{
    console.log(val)
    if(val==null||val.length==0){
        searchdata.send_time_start = ''
        searchdata.send_time_end = ''
        
    }else{
        searchdata.send_time_start = val[0]
        searchdata.send_time_end = val[1]
    }
    searchdata.page=1
    getlist()
}

//选择状态
const options = reactive({
    data:[
        {
            id:0,
            title:'等待发送'
        },
        {
            id:1,
            title:'部分成功'
        },
        {
            id:2,
            title:'发布成功'
        },
        {
            id:3,
            title:'发布失败'
        }
    ]
})

//选择状态
const searchselect = (val)=>{
    console.log(val)
    if(val.toString()==''){
        searchdata.status=''
    }else{
        searchdata.status=val
    }
    searchdata.page=1
    getlist()
}

//重置
const resetsearch = ()=>{
    searchdata.title = ''
    searchdata.status = ''
    searchdata.send_time_start = ''
    searchdata.send_time_end = ''
    searchdata.content = ''
    choosetime.data = []
    searchdata.page=1
    searchdata.corp_id = ''
    getlist()
}

//搜索
const searchinput = (val)=>{
    console.log(val)
    searchdata.page=1
    searchdata.title=val
    getlist()
}
//搜索
const searchpeng = (val)=>{
    console.log(val)
    searchdata.page=1
    searchdata.content=val
    getlist()
}


//列表数据
const tableData = reactive({
    data:[]
})
//获取列表
const getlist = ()=>{
    newsendfriendlist(searchdata).then((response)=>{
        console.log('---列表')
        console.log(response.data.data.data)
        
        tableData.data = response.data.data.data
        total.value = response.data.data.total
    })
}
//成员总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//去朋友圈
const todetail = (id)=>{
    router.push({path: '/navxxcd/friendCircle',query:{id:id}})
}
//删除
const detailbtn = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelfriendcircle({id:id}).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                //人员列表
                getlist()
            }
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}


//发送状态弹窗
const isshowsendtype = ref(false)

//发送状态弹窗
const sendtypeData = reactive({
    data:[]
})

//打开发送状态弹窗
const opensendtype = (row)=>{
    isshowsendtype.value = true
    newsendlist({id:row.id}).then((response)=>{
        console.log('---发送状态')
        console.log(response.data.data.data)
        sendtypeData.data = response.data.data.data
    })
}
//重新发送
const restsend = (id)=>{
    ElMessageBox.confirm(
    '是否确认重新发送?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newrepsend({id:id}).then((response)=>{
            ElMessage({
                type:'success',
                message: '操作成功',
            })
            //人员列表
            getlist()
            isshowsendtype.value = false
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}

//删除结果弹窗
const isshowdelrest = ref(false)

//删除状态弹窗
const delrestData = reactive({
    data:[]
})

//打开发送状态弹窗
const opendelrest = (row)=>{
    isshowdelrest.value = true
    sendrestlist(_url2,{momentId:row.id,type:2}).then((response)=>{
        console.log('---发送状态')
        console.log(response.data.result)
        delrestData.data = response.data.result
    })
}

//终止发送

const stopbtn = (id)=>{
    ElMessageBox.confirm(
    '是否确认终止执行?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newstopsend({id:id}).then((response)=>{
            ElMessage({
                type:'success',
                message: '操作成功',
            })
            //人员列表
            getlist()
        })
        
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}

//重新执行
const restdel = (id)=>{
    ElMessageBox.confirm(
    '是否确认重新执行?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        repset(_url2,{id:id}).then((response)=>{
            ElMessage({
                type:'success',
                message: '操作成功',
            })
            //人员列表
            getlist()
        })
        
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}

</script>
<style scoped>


:deep(.t_search_select .select-trigger) {
    width:100%
}

:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>